import { BASE_URL_API } from "./Config";

export async function Call(endpoint: string, method: string, body?: any): Promise<any> {
  try {
    const token = localStorage.getItem("authToken");
    const uri = `${BASE_URL_API}${endpoint}`;

    const headers: HeadersInit = {
      Authorization: `Bearer ${token}`,
    };

    let requestBody: BodyInit | null = null;

    if (body instanceof FormData) {
      requestBody = body;
    } else if (body) {
      headers["Content-Type"] = "application/json";
      requestBody = JSON.stringify(body);
    }

    const response: Response = await fetch(uri, {
      method,
      headers,
      body: requestBody,
    });
    /*
    const response: Response = await fetch(uri, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: requestBody ? requestBody : undefined
    });
*/
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.message === "Token non valido") {
        alert(errorData.message);
        localStorage.removeItem("authToken");
        localStorage.removeItem("userRole");
        localStorage.removeItem("userName");
        window.location.href = "/login";
      }
      console.error("Errore API lato server:", errorData);
      return new Response(JSON.stringify(errorData), {
        status: response.status,
        headers: { "Content-Type": "application/json" },
      });
    }

    return response;
  } catch (error) {
    console.error("Errore di rete:", error);
    return new Response(
      JSON.stringify({
        success: false,
        message: "Errore interno del server o server non raggiungibile",
      }),
      {
        status: 500,
        headers: { "Content-Type": "application/json" },
      }
    );
  }
}
